export default "__VITE_ASSET__4ff8dc7e__"